import { render, staticRenderFns } from "./DatosSertec.vue?vue&type=template&id=31766419&"
import script from "./DatosSertec.vue?vue&type=script&lang=ts&"
export * from "./DatosSertec.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports